export default __webpack_public_path__ + "static/media/Vitamin.1e519643.jpeg";